import React, { useEffect } from "react";

const FAQWidgetComponent = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    script.src =
      `${baseUrl}/api/widgets/faq-widget.js?organization_id=org_32AyYjsNDEojsPpV3y5mggD3LNt&widget_id=56bbffde-916c-4f8a-814f-d256b2166553`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="faq-widget-container" />;
};

export default FAQWidgetComponent;
